export const CLOUDFRONT_URL = 'https://d2uret4ukwmuoe.cloudfront.net/';
